module.exports = __webpack_public_path__ + "static/img/公司13.b94516b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/公司13.jpg
// module id = Knbs
// module chunks = 1